import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from 'antd';

import { ModalSto } from 'components/sto';

const TooltipInfoModal = (props) => (
    <ModalSto okText="general.ok" onOk={props.onOk} visible={props.visible}>
        <React.Fragment>
            <div className="tooltip">
                <Icon className="popup-hint" id="info-icon" type="question-circle" />
                {props.type === 'availableCredit' && (
                    <div className="tooltip-details">
                        <h2 className="pop-up-title">
                            <FormattedMessage id="popup.available.credit.title" />
                        </h2>
                        <p>
                            <FormattedMessage id="popup.available.credit.text" />
                        </p>
                    </div>
                )}
                {props.type === 'creditLimit' && (
                    <div className="tooltip-details">
                        <h2 className="pop-up-title">
                            <FormattedMessage id="popup.credit.limit.title" />
                        </h2>
                        <p>
                            <FormattedMessage id="popup.credit.limit.text" />
                        </p>
                    </div>
                )}
            </div>
        </React.Fragment>
    </ModalSto>
);

export default TooltipInfoModal;
